(function (){
    $(document).ready(function (e) {
        var isUpdatePage = $('.update-subscribe-page').length > 0;
        if (isUpdatePage) {
            var subscriptionPageHandle = $('.subscribe-page-main-wrapper').attr('data-subscription-page');
            $.ajax({
                url: "/pages/" + subscriptionPageHandle,
                type: 'GET',
                dataType: 'html',
                success: function(data) {
                    var mainSectionId = $('.subscribe-page', $(data)).attr('id').replace('shopify-section-', '');
                    $.ajax({
                        url: "/pages/" + subscriptionPageHandle + "?section_id=" + mainSectionId + "&view=update-subscription",
                        type: 'GET',
                        dataType: 'html',
                        success: function(data) {
                            var $section = $(data);
                            $('.update-subscription-main').html($section.html());
                            var sections = new theme.Sections();
                            var $productSections = $('.update-subscription-main [data-section-type="product-template"]');
                            $productSections.each(function (i) {
                                sections._createInstance($(this), theme.Product);
                            });
                            initSubscriptionPage();
                        }
                    });
                }
            });
        }
        else {
            initSubscriptionPage();
        }
    });
    function initSubscriptionPage(){
        if (!$('.subscribe-page-wrapper').length){
            return;
        }
        var $window = $(window),
            headerIsDisabled = $('.subscribe-page-main-wrapper').attr('data-header-disabled') === 'true',
            $confirmTable = $('.confirm_table'),
            $mainNappiesSection = $('.subscription-product-nappies'),
            $mainNextBtn = $('.btn--next'),
            $mainPrevBtn = $('.btn--prev'),
            $addSubscriptionBtn = $('.add-subscription-btn'),
            $currentTotalSubscription = $('.current-total-sum'),
            $currentTotalAll = $('.current-total-all-sum'),
            $currentTotalAllCompare = $('.current-total-all-sum-compare'),
            $subscriptionSavings = $('.subscription-savings'),
            $addOffersPopup = $('#add-cart-popup'),
            $loadingOverlay = $('#loading-overlay'),
            $updatedPricePopup = $('#update-price-popup'),
            includeShippingInTotal = $currentTotalAllCompare.attr('data-include-shipping') ? +$currentTotalAllCompare.attr('data-include-shipping') : 0,
            offersEnabled = $('.section-subscribe-offers').length ? true : false,
            switchNappiesToSubscription = localStorage.getItem('switchNappiesToSubscription'),
            preselectedProductId = localStorage.getItem('preselectedProductId'),
            maxStep = $mainNextBtn.attr('data-max'),
            currentStep = 1,
            currentTotalSubscription = 0,
            currentTotalOneOff = 0,
            currentTotalAll = 0,
            currentTotalSubscriptionCompare = 0,
            currentTotalOneOffCompare = 0,
            currentTotalAllCompare = 0,
            initialTotalPrice = 0,
            allSelectedProducts = [],
            subscriptionProducts = [],
            unpausedSubscriptionProducts = [],
            subscriptionSpecialOffersInCart = [],
            oneTimeProducts = [],
            oosProducts = [],
            subscriptionInCart = $('.subscribe-page-wrapper').attr('data-subscription-in-cart') === 'true',
            hideNextOrderTotal = $('.subscribe-page-wrapper').attr('data-hide-next-total') === 'true',
            extraProducts = false,
            subscriptionId = $addSubscriptionBtn.attr('data-subscription-id'),
            subscriptionUpdateUrl = $addSubscriptionBtn.attr('data-subscription-update-url'),
            customerId = $addSubscriptionBtn.attr('data-customer-id'),
            isUpdatePage = $('.update-subscribe-page').length > 0,
            nappiesTypeChosen = subscriptionInCart && $mainNappiesSection.length > 0,
            subscriptionUrl = $addSubscriptionBtn.attr('data-subscription-url'),
            mainSellingPlansIds = $('#main-selling-plans-ids').length ? JSON.parse(document.getElementById('main-selling-plans-ids').innerHTML) : false,
            relMainSellingPlansIds = $('#rel-main-selling-plans-ids').length ? JSON.parse(document.getElementById('rel-main-selling-plans-ids').innerHTML) : false,
            subscriptionSpecialOffersSettings = $('#subscription-special-offers-settings').length ? JSON.parse(document.getElementById('subscription-special-offers-settings').innerHTML) : false,
            cartJson = $('#cart-json').length ? JSON.parse(document.getElementById('cart-json').innerHTML) : false,
            switchOffersToSubscription = $('#switch-on-off-to-subscription').length ? JSON.parse(document.getElementById('switch-on-off-to-subscription').innerHTML) : false;

        topMessage();
        localStorage.removeItem('switchNappiesToSubscription');
        localStorage.removeItem('preselectedProductId');
        if (subscriptionSpecialOffersSettings && cartJson) {
            $.each(cartJson.items, function(i, item){
                if (item.selling_plan_allocation && item.properties && item.properties['_gwa_subscription_special_offer'] && item.properties['_gwa_subscription_special_offer'] === '1'){
                    subscriptionSpecialOffersInCart.push(item);
                }
            })
        }

        if ($mainNappiesSection.length) {
            checkSelectedNappies();
        }
        if (headerIsDisabled) {
            addShadowToHeader();
        }

        attachListeners();

        if (!subscriptionInCart) {
            var currentVariant = getQueryVariable('variant');
            if (currentVariant && !$('.radio-size-wrapper.main-radio').find('[data-id="' + currentVariant + '"]').hasClass('label-disabled')) {
                $('.radio-size-wrapper.main-radio').find('[data-id="' + currentVariant + '"] input').attr('checked', true).trigger('change');
                if ($('.change-nappy-type').length) {
                    var selectedProductId = $('.radio-size-wrapper.main-radio').find('[data-id="' + currentVariant + '"] input').attr('data-product-id');
                    var $relatedTypeInput = $('.change-nappy-type[value="'+selectedProductId+'"]');
                    setTimeout(function (){
                        $relatedTypeInput.trigger('click');
                    }, 500);
                }

            }
            else if (!currentVariant && preselectedProductId && $('.change-nappy-type').length){
                setTimeout(function (){
                    $('.change-nappy-type[value="'+preselectedProductId+'"]').trigger('click');
                }, 500);
            }
        }

        if (getQueryVariable('step')){
            goToStep(+$('.subscribe-section[data-url="'+getQueryVariable('step')+'"]').attr('data-step'));
        }
        else {
            goToStep(1);
        }

        if ($('.subscription-product-offer.has-additional-variants').length) {
            adjustOfferBlockHeight();
        }

        $('.subscription-product-active, .one-time-product-active').each(function () {
            updateProductPriceAndNote($(this));
        });

        $('.subscription-product-active, .one-time-product-active, .subscription-oos-product-active, .one-time-oos-product-active, .subscription-product-paused').each(function () {
            showVariantImage($(this));
        });

        changeButtonClass();
        initCollectionScroll();
        updateOneOffToSubscription();

        function attachListeners() {
            if ($mainNappiesSection.length) {
                $('.single-option-selector__radio', $mainNappiesSection).on('change', function () {
                    checkSelectedNappies();
                });
            }

            if (headerIsDisabled) {
                $window.on('scroll', function(){
                    addShadowToHeader();
                });
            }

            $('.subscribe-page-wrapper').on('subscriptionChanged', function (){
                $('.subscription-product-active, .one-time-product-active').each(function () {
                    updateProductPriceAndNote($(this));
                });
            });

            $('.change-nappy-type').on('change', function(){
                var productId = $(this).val();
                var $relatedOptions = $('.main-product-options .single-option-selector__radio[data-product-id="'+productId+'"]')
                var $relatedOptionsWrappers = $relatedOptions.closest('.radio-size-wrapper');
                $('.main-product-options .radio-size-wrapper').hide();
                if (!nappiesTypeChosen) {
                    $relatedOptionsWrappers.show();
                    $('.section-subscribe-nappies').slideDown(500);
                    if (!isUpdatePage) {
                        $('.subscription-frequency').slideDown(500);
                        $('.nappies-types').addClass('collapsed');
                    }
                    nappiesTypeChosen = true;
                    changeButtonClass();
                }
                else {
                    if (!$relatedOptions.filter(':checked').length){
                        $mainNextBtn.addClass('disabled');
                        $addSubscriptionBtn.addClass('disabled');
                    }
                    else {
                        $mainNextBtn.removeClass('disabled');
                        $addSubscriptionBtn.removeClass('disabled');
                    }
                    $relatedOptionsWrappers.fadeIn(300);
                    changeButtonClass();
                }
            });

            $('.add-subscription-product').on('click', function(){
                var $thisContainer = $(this).closest('.subscription-product');
                if ($('.option-main-line-default', $thisContainer).length) {
                    $('.custom-select-btn', $thisContainer).addClass('selection-required');
                    setTimeout(function (){
                        $('.custom-select-btn', $thisContainer).removeClass('selection-required');
                    }, 1000)
                }
                else {
                    if ($thisContainer.hasClass('one-purchase-type-only')){
                        $('.add-one-time-btn', $thisContainer).addClass('btn-disabled');
                    }
                    $thisContainer.addClass('subscription-product-active');
                    $('.price-from', $thisContainer).hide();
                    $('.subscription-price-wrapper', $thisContainer).show();
                    $(this).closest('.product-single__form').find('.subscription-another-item').slideDown(200);
                    updateProductPriceAndNote($thisContainer, $('.js-qty__num-subscribe', $thisContainer));
                }
            });

            $('.add-one-time-btn').on('click', function(){
                var $thisContainer = $(this).closest('.subscription-product');
                if ($('.option-main-line-default', $thisContainer).length) {
                    $('.custom-select-btn', $thisContainer).addClass('selection-required');
                    setTimeout(function (){
                        $('.custom-select-btn', $thisContainer).removeClass('selection-required');
                    }, 1000)
                }
                else {
                    if ($thisContainer.hasClass('one-purchase-type-only')){
                        $('.add-subscription-product', $thisContainer).addClass('btn-disabled');
                    }
                    $thisContainer.addClass('one-time-product-active');
                    $('.price-from', $thisContainer).hide();
                    $('.subscription-price-wrapper', $thisContainer).show();
                    $(this).closest('.product-single__form').find('.subscription-another-item').slideDown(200);
                    updateProductPriceAndNote($thisContainer, $('.js-qty__num-one-time', $thisContainer));
                }
            });

            $(document).on('change keyup','.subscription-product .js-qty__num', function (e) {
                updateProductPriceAndNote($(this).closest('.subscription-product'), $(this), e.type);
            });

            $(document).on('change', '.subscription-product .single-option-selector__radio', function(){
                var $thisContainer = $(this).closest('.subscription-product');
                $('.price-from', $thisContainer).hide();
                $('.main-product-options .subscription-price-wrapper', $thisContainer).show();
                updateProductPriceAndNote($thisContainer);
                showVariantImage($thisContainer);
            });

            $('.remove-from-subscription').on('click', function (){
                var $thisContainer = $(this).closest('.subscription-product');
                var $variantOption = $('.product-single__variants option:selected', $thisContainer);
                var $qntSelector = $('.js-qty__num-subscribe', $thisContainer);
                var thisDefaultQnt = parseInt($variantOption.attr('data-subscribe-qnt'));
                var $additionalItemsBlock = $(this).closest('.product-single__form').find('.subscription-another-item');
                $thisContainer.removeClass('subscription-product-active');
                $qntSelector.val(thisDefaultQnt).trigger('change');
                if ($additionalItemsBlock.length && !$thisContainer.hasClass('additional-product-options')){
                    $('.additional-product-options', $additionalItemsBlock).removeClass('subscription-product-active');
                    $additionalItemsBlock.slideUp(200, function(){
                        $('.additional-product-options', $additionalItemsBlock).remove();
                    });
                }
                if ($thisContainer.hasClass('one-purchase-type-only')){
                    $('.add-one-time-btn', $thisContainer).removeClass('btn-disabled');
                }
                updateProductPriceAndNote($thisContainer, $qntSelector);
            });

            $('.remove-oos-from-subscription').on('click', function (){
                var $thisContainer = $(this).closest('.subscription-product');
                $thisContainer.removeClass('subscription-oos-product-active');
            });

            $('.add-oos-subscription-product').on('click', function (){
                var $thisContainer = $(this).closest('.subscription-product');
                $thisContainer.addClass('subscription-oos-product-active');
            });

            $('.remove-oos-one-time').on('click', function (){
                var $thisContainer = $(this).closest('.subscription-product');
                $thisContainer.removeClass('one-time-oos-product-active');
            });

            $('.add-oos-one-time-product').on('click', function (){
                var $thisContainer = $(this).closest('.subscription-product');
                $thisContainer.addClass('one-time-oos-product-active');
            });

            $('.remove-one-time').on('click', function (){
                var $thisContainer = $(this).closest('.subscription-product');
                var $variantOption = $('.product-single__variants option:selected', $thisContainer);
                var $qntSelector = $('.js-qty__num-one-time', $thisContainer);
                var thisDefaultQnt = $variantOption.attr('data-subscribe-qnt') ? parseInt($variantOption.attr('data-subscribe-qnt')) : 1;
                var $additionalItemsBlock = $(this).closest('.product-single__form').find('.subscription-another-item');
                $thisContainer.removeClass('one-time-product-active');
                $qntSelector.val(thisDefaultQnt).trigger('change');
                if ($additionalItemsBlock.length && !$thisContainer.hasClass('additional-product-options')){
                    $('.additional-product-options', $additionalItemsBlock).removeClass('one-time-product-active');
                    $additionalItemsBlock.slideUp(200, function(){
                        $('.additional-product-options', $additionalItemsBlock).remove();
                    });
                }
                if ($thisContainer.hasClass('one-purchase-type-only')){
                    $('.add-subscription-product', $thisContainer).removeClass('btn-disabled');
                }
                updateProductPriceAndNote($thisContainer, $qntSelector);
            });

            $('.add-another-item-once').on('click', function(){
                var $productContainer = $(this).closest('.subscription-another-item').find('.subscription-product');
                if ($productContainer.hasClass('subscription-oos-product')){
                    $productContainer.addClass('subscription-oos-product-active').slideDown(300);
                }
                else {
                    $productContainer.addClass('subscription-product-active').slideDown(300);
                }
                $(this).hide();
                calcCurrentTotal();
            });

            $('.remove-additional-product').on('click', function(){
                var $productContainer = $(this).closest('.subscription-product');
                if ($productContainer.hasClass('subscription-oos-product')){
                    $productContainer.removeClass('subscription-oos-product-active').slideUp(300, function(){
                        $('.add-another-item-once').show();
                    });
                }
                else {
                    $productContainer.removeClass('subscription-product-active').slideUp(300, function(){
                        $('.add-another-item-once').show();
                    });
                }
                calcCurrentTotal();
            });

            $('.subscription-product-offer .item-main .custom-ratio-image-wrapper').on('click', function(e){
                if ($(this).hasClass('drag-start')){
                    return;
                }
                if ($window.width() < 768){
                    $(this).toggleClass('hovered');
                }
                var $productContainer = $(this).closest('.subscription-product-offer');
                if ($productContainer.hasClass('subscription-product-disabled') || $productContainer.hasClass('subscription-product-paused')) {
                    return;
                }
                if ($('.add-subscription-product:not(.btn-disabled)', $productContainer).length) {
                    if ($productContainer.hasClass('subscription-product-active')) {
                        $('.remove-from-subscription', $productContainer).trigger('click');
                    }
                    else {
                        $('.add-subscription-product', $productContainer).trigger('click');
                    }
                }
                else {
                    if ($productContainer.hasClass('one-time-product-active')) {
                        $('.remove-one-time', $productContainer).trigger('click');
                    }
                    else {
                        $('.add-one-time-btn:not(.btn-disabled)', $productContainer).trigger('click');
                    }
                }
            });

            $('[name="frequency"]').on('change', function () {
                $('.current-frequency').text($(this).attr('data-option-name'));
            });

            $mainNextBtn.on('click', function () {
                goToStep(currentStep + 1);
            });

            $mainPrevBtn.on('click', function () {
                goToStep(currentStep - 1);
            });

            $confirmTable.on('click', '[data-step-to]', function () {
                var $this = $(this);
                var thisStep = parseInt($this.attr('data-step-to'));
                goToStep(thisStep);
            });

            $('#back-to-subscription-btn').on('click', function() {
                $(this).closest('.animatedModal').fadeOut(200);
                goToStep(2);
            });

            $addSubscriptionBtn.on('click', function () {
                $('.top-message').hide();
                extraProducts = false;
                if (!$('.subscription-product-main.subscription-product-active').length){
                    goToStep(1);
                    return;
                }

                if (!$(this).hasClass('popup-subscription-btn')) {
                    getSubscriptionProducts(function () {
                        if (subscriptionId && currentTotalAll != initialTotalPrice) {
                            if (currentTotalOneOff > 0) {
                                $('.popup-message', $updatedPricePopup).html(theme.subscriptionStrings.subscription_with_one_time_price_changed);
                                $('.updated_price').text(theme.Currency.formatMoney(currentTotalSubscription, theme.strings.moneyFormat));
                                $('.updated_total_price').text(theme.Currency.formatMoney(currentTotalAll, theme.strings.moneyFormat));
                            }
                            else {
                                $('.popup-message', $updatedPricePopup).html(theme.subscriptionStrings.subscription_price_changed);
                                $('.updated_price').text(theme.Currency.formatMoney(currentTotalSubscription, theme.strings.moneyFormat));
                            }
                            $('.updated_price').text(theme.Currency.formatMoney(currentTotalSubscription, theme.strings.moneyFormat));
                            if (hideNextOrderTotal) {
                                $('.updated_total_price').parent().prev('br').remove();
                                $('.updated_total_price').parent().remove();
                            }
                            $updatedPricePopup.fadeIn(500);
                        }
                        else if (!extraProducts && offersEnabled && $addOffersPopup.length) {
                            $addOffersPopup.fadeIn(500);
                        }
                        else {
                            $loadingOverlay.fadeIn(500);
                            addOrUpdate();
                        }
                    });
                }
                else {
                    $loadingOverlay.fadeIn(500);
                    addOrUpdate();
                }
            });

            $('.unpause-subscription-product').on('click', function(){
                var $thisContainer = $(this).closest('.subscription-product');
                if ($thisContainer.hasClass('subscription-product-unpaused')){
                    $thisContainer.removeClass('subscription-product-unpaused subscription-product-active');
                    $(this).text($(this).attr('data-unpause-text'));
                }
                else {
                    $thisContainer.addClass('subscription-product-unpaused subscription-product-active');
                    $(this).text($(this).attr('data-pause-text'));
                }
                updateProductPriceAndNote($thisContainer);
            });

            $window.on('scroll', function () {
                changeButtonClass();
            });

            $window.on('resize', function () {
                changeButtonClass();
            });
        }

        function checkSelectedNappies() {
            if ($('.single-option-selector__radio:checked', $mainNappiesSection).length){
                $mainNappiesSection.addClass('subscription-product-active');
                $addSubscriptionBtn.removeClass('disabled');
                $mainNextBtn.removeClass('disabled');
                $('.current-total-hidden').removeClass('current-total-hidden');
                updateQueryStringParam('variant', $(this).attr('data-variant-id'));
                calcCurrentTotal();
            }
        }

        function changeButtonClass() {
            let footerOffset = $('#shopify-section-footer').offset().top - 50;
            let windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            let nextNavPseudo = $('.subscription-nav_wrapper_pseudo');
            if ($(window).scrollTop() >= (footerOffset - windowHeight)) {
                $('.subscription-nav_wrapper').removeClass('active-btn');
                nextNavPseudo.addClass('hide');
            } else {
                $('.subscription-nav_wrapper').addClass('active-btn');
                nextNavPseudo.removeClass('hide');
            }
        }

        function showVariantImage($subscriptionProduct) {
            var $container = $subscriptionProduct.closest('.product-single__form');
            if (!$container.length || !$container.attr('data-subscription-offer')){
                return;
            }
            var $selectedOption = $('.product-single__variants option:selected', $container);
            if (!$selectedOption.length){
                return;
            }
            var newImgSrc = $selectedOption.attr('data-variant-img-alt') ? $selectedOption.attr('data-variant-img-alt') : $selectedOption.attr('data-variant-img-large');
            var hoverImgSrc = $selectedOption.attr('data-variant-img-hover');
            var originalHoverImgSrc = $('.hover-image', $container).attr('data-original-src');
            if (newImgSrc) {
                $('.subscription-product-image', $container).removeAttr('data-src').attr('src', newImgSrc);
            }
            if (hoverImgSrc) {
                $('.hover-image', $container).removeAttr('data-src').attr('src', hoverImgSrc);
            }
            else if (originalHoverImgSrc) {
                $('.hover-image', $container).removeAttr('data-src').attr('src', originalHoverImgSrc);
            }
        }

        function updateOneOffToSubscription() {
            if (!switchNappiesToSubscription || !switchOffersToSubscription || subscriptionInCart) {
                return;
            }
            $.each(cartJson.items, function(i, item){
                if ($.isEmptyObject(item.properties) && switchOffersToSubscription.indexOf(item.product_id) >=0){
                    var $productBlock = $('.subscription-product-offer option[value="'+item.id+'"]').closest('.subscription-product-offer');
                    if ($productBlock.hasClass('subscription-oos')){
                        return;
                    }
                    if ($productBlock.hasClass('one-time-enabled')){
                        $('.remove-one-time', $productBlock).trigger('click');
                    }
                    $('.js-qty__num-subscribe', $productBlock).val(item.quantity);
                    $('.add-subscription-product', $productBlock).trigger('click');
                }
            });
        }

        function updateProductPriceAndNote($thisContainer, $activeQntSelector, eventType) {
            var isSubscription = $thisContainer.hasClass('subscription-product-active') || $thisContainer.hasClass('subscription-product-paused');
            var isOneTime = $thisContainer.hasClass('one-time-product-active');
            var isSubscriptionOos = $thisContainer.hasClass('subscription-oos');
            var $addSubscriptionBtn = $('.add-subscription-product', $thisContainer);
            var hasSubscriptionOption = $addSubscriptionBtn.length > 0;
            var hasOneTimeOption = $('.add-one-time-btn', $thisContainer).length > 0;
            var $additionalItemsBlock = $(this).closest('.product-single__form').find('.subscription-another-item');
            var $variantOption = $('.product-single__variants option:selected', $thisContainer);
            var $qntMaxNote = $('.quantity-max-note', $thisContainer);
            var thisDefaultQnt = $variantOption.attr('data-subscribe-qnt') ? parseInt($variantOption.attr('data-subscribe-qnt')) : 1;
            var oosForSubscription = $variantOption.attr('data-subscription-oos') === 'true';
            var totalPrice = 0;
            var totalComparePrice = 0;
            var shippingPrice = 0;

            if ($thisContainer.hasClass('subscription-product-main')){
                var thisSubQnt = thisDefaultQnt;
                shippingPrice = includeShippingInTotal;
            }
            else {
                var $qntSubInput = $('.js-qty__num-subscribe', $thisContainer);
                var thisSubQnt = isSubscription && $qntSubInput.val() ? parseInt($qntSubInput.val()) : 0;
            }

            var $qntOneTimeInput = $('.js-qty__num-one-time', $thisContainer);
            var thisOneTimeQnt = isOneTime && $qntOneTimeInput.val() ? parseInt($qntOneTimeInput.val()) : 0;

            var maxQnt = parseInt($variantOption.attr('data-max'));
            var increment = 1;
            if ($variantOption.attr('data-increment')) {
                increment = +$variantOption.attr('data-increment');
                if (increment > 1 && maxQnt && maxQnt > 0 && (eventType === 'change' || !eventType)) {
                    maxQnt = Math.floor(maxQnt / increment) * increment;
                }
            }
            var changedToMax = false;
            if (maxQnt && maxQnt > 0) {
                if ($activeQntSelector && isSubscription && isOneTime && maxQnt < thisSubQnt + thisOneTimeQnt){
                    if ($activeQntSelector.hasClass('js-qty__num-subscribe')){
                        $activeQntSelector.val(maxQnt - thisOneTimeQnt);
                        thisSubQnt = maxQnt - thisOneTimeQnt;
                    }
                    else {
                        $activeQntSelector.val(maxQnt - thisSubQnt);
                        thisOneTimeQnt = maxQnt - thisSubQnt;
                    }
                    $qntMaxNote.text(maxQnt + ' in stock').slideDown(200);
                    $activeQntSelector.trigger('change');
                    changedToMax = true;
                }
                else {
                    if (isSubscription && maxQnt < thisSubQnt) {
                        $qntSubInput.val(maxQnt);
                        thisSubQnt = maxQnt;
                        $qntMaxNote.text(maxQnt + ' in stock').slideDown(200);
                        $qntSubInput.trigger('change');
                        changedToMax = true;
                    }
                    if (isOneTime && maxQnt < thisOneTimeQnt) {
                        $qntOneTimeInput.val(maxQnt);
                        thisOneTimeQnt = maxQnt;
                        $qntMaxNote.text(maxQnt + ' in stock').slideDown(200);
                        $qntOneTimeInput.trigger('change');
                        changedToMax = true;
                    }
                }

                if (changedToMax) {
                    return;
                }
                else if (maxQnt > thisSubQnt + thisOneTimeQnt) {
                    $qntMaxNote.slideUp(200);
                }
            }
            if ((eventType === 'change' || !eventType) && increment > 1){
                if (isSubscription && thisSubQnt % increment > 0){
                    var newSubQnt = Math.max(Math.floor(thisSubQnt / increment) * increment, increment);
                    $qntSubInput.val(newSubQnt);
                    thisSubQnt = newSubQnt;
                    $qntSubInput.trigger('change');
                    changedToMax = true;
                }
                else if (isSubscription && thisSubQnt > increment){
                    $qntSubInput.closest('.js-qty').find('.js-qty__adjust--minus').removeAttr('disabled');
                }
                if (isOneTime && thisOneTimeQnt % increment > 0) {
                    var newOneTimeVal = Math.max(Math.floor(thisOneTimeQnt / increment) * increment, increment);
                    $qntOneTimeInput.val(newOneTimeVal);
                    thisOneTimeQnt = newOneTimeVal;
                    $qntOneTimeInput.trigger('change');
                    changedToMax = true;
                }
                if (changedToMax) {
                    return;
                }
            }

            var totalQnt = thisSubQnt + thisOneTimeQnt;

            var thisPerPackQnt = parseInt($variantOption.attr('data-per-pack'));

            var thisSubPrice = $variantOption.attr('data-subscribe-price') ? parseInt($variantOption.attr('data-subscribe-price')) : 0;
            var thisSubComparePrice = parseInt($variantOption.attr('data-price'));
            var thisOneTimePrice = $variantOption.attr('data-custom-price') ? parseInt($variantOption.attr('data-custom-price')) : parseInt($variantOption.attr('data-price'));
            var thisOneTimeComparePrice = $variantOption.attr('data-compare-price') ? parseInt($variantOption.attr('data-compare-price')) : parseInt($variantOption.attr('data-price'));

            var $thisPrice = $thisContainer.find('.subscription-product-total-price');
            var $thisComparePrice = $thisContainer.find('.subscription-original-total-price');

            var packUnit = $variantOption.attr('data-pack-type') ? $variantOption.attr('data-pack-type').split('/') : false;

            if (hasSubscriptionOption && oosForSubscription) {
                $addSubscriptionBtn.addClass('subscription-oos-btn').html(theme.strings.soldOut);
                thisSubQnt = 0;
            }
            else {
                $addSubscriptionBtn.removeClass('subscription-oos-btn').html(theme.strings.addSubscription);
            }

            if (isSubscription) {
                if (thisSubQnt === 0){
                    $thisContainer.removeClass('subscription-product-active');
                    $qntSubInput.val(thisDefaultQnt).trigger('change');
                    if ($additionalItemsBlock.length && !$thisContainer.hasClass('additional-product-options')){
                        $('.additional-product-options', $additionalItemsBlock).removeClass('subscription-product-active');
                        $additionalItemsBlock.slideUp(200, function(){
                            $('.additional-product-options', $additionalItemsBlock).remove();
                        });
                    }
                    if ($thisContainer.hasClass('one-purchase-type-only')){
                        $('.add-one-time-btn', $thisContainer).removeClass('btn-disabled');
                    }
                    return;
                } else {
                    totalPrice += thisSubQnt * thisSubPrice;
                    totalComparePrice += thisSubQnt * thisSubComparePrice;
                }
            }
            if (isOneTime) {
                if (thisOneTimeQnt === 0){
                    $thisContainer.removeClass('one-time-product-active');
                    $qntOneTimeInput.val(thisDefaultQnt).trigger('change');
                    if ($thisContainer.hasClass('one-purchase-type-only')){
                        $('.add-subscription-product', $thisContainer).removeClass('btn-disabled');
                    }
                    return;
                } else {
                    totalPrice += thisOneTimeQnt * thisOneTimePrice;
                    totalComparePrice += thisOneTimeQnt * thisOneTimeComparePrice;
                }
            }
            if (!isOneTime && !isSubscription){
                if (hasSubscriptionOption){
                    totalPrice = thisDefaultQnt * thisSubPrice;
                    totalComparePrice = thisDefaultQnt * thisSubComparePrice;
                }
                else if (hasOneTimeOption){
                    totalPrice = thisDefaultQnt * thisOneTimePrice;
                    totalComparePrice = thisDefaultQnt * thisOneTimeComparePrice;
                }
                totalQnt = thisDefaultQnt;
            }
            $thisPrice.text(theme.Currency.formatMoney((totalPrice), theme.strings.moneyFormat));

            if (totalComparePrice + shippingPrice > totalPrice){
                $thisComparePrice.text(theme.Currency.formatMoney((totalComparePrice + shippingPrice), theme.strings.moneyFormat)).show();
            }
            else {
                $thisComparePrice.hide();
            }

            if (packUnit) {
                $('.packs-qnt', $thisContainer).text(totalQnt + ' x ' + (totalQnt === 1 ? packUnit[0] : packUnit[1]));
                $('.per-pack-qnt', $thisContainer).text(totalQnt * thisPerPackQnt);
            }
            if ($thisContainer.hasClass('one-purchase-type-only') && $('.single-option-selector__radio[data-subscription-sate="false"][data-original-sate="true"]', $thisContainer).length){
                $('.single-option-selector__radio[data-subscription-sate="false"][data-original-sate="true"]', $thisContainer).each(function(i, option){
                    if (isSubscription) {
                        $(this).attr('disabled', true).addClass('disabled').next('label').addClass('label-disabled');
                    }
                    else {
                        $(this).removeAttr('disabled').removeClass('disabled').next('label').removeClass('label-disabled');
                    }
                });
                if ($('.single-option-selector__radio[data-subscription-sate="false"][data-original-sate="true"]:checked', $thisContainer).length){
                    $('.add-subscription-product', $thisContainer).addClass('btn-disabled');
                }
                else if (!isOneTime){
                    $('.add-subscription-product', $thisContainer).removeClass('btn-disabled');
                }
            }
            if ($thisContainer.hasClass('one-purchase-type-only') && $thisContainer.closest('.product-single__form').find('.label-disabled-paused').length){
                $thisContainer.closest('.product-single__form').find('.add-one-time-btn').addClass('btn-disabled');
            }
            calcCurrentTotal();
        }

        function calcCurrentTotal() {
            currentTotalSubscription = 0;
            currentTotalOneOff = 0;
            currentTotalAll = 0;
            currentTotalSubscriptionCompare = 0;
            currentTotalOneOffCompare = 0;
            currentTotalAllCompare = 0;
            $('.subscription-product-active, .one-time-product-active').each(function () {
                var $thisContainer = $(this);
                var isSubscriptionOos = $thisContainer.hasClass('subscription-oos');
                var $optionSelected = $('.product-single__variants option:selected', $thisContainer);
                if ($thisContainer.hasClass('subscription-product-main')){
                    var thisSubQnt = +$optionSelected.attr('data-subscribe-qnt');
                    var thisOneTimeQnt = 0;
                }
                else {
                    var isSubscription = $thisContainer.hasClass('subscription-product-active');
                    var isOneTime = $thisContainer.hasClass('one-time-product-active');

                    var $qntSubInput = $('.js-qty__num-subscribe', $thisContainer);
                    var thisSubQnt = isSubscription ? parseInt($qntSubInput.val()) : 0;

                    var $qntOneTimeInput = $('.js-qty__num-one-time', $thisContainer);
                    var thisOneTimeQnt = isOneTime ? parseInt($qntOneTimeInput.val()) : 0;
                }
                var thisSubPrice = isSubscriptionOos ? 0 : parseInt($optionSelected.attr('data-subscribe-price'));
                var thisOneTimePrice = $optionSelected.attr('data-custom-price') ? parseInt($optionSelected.attr('data-custom-price')) : parseInt($optionSelected.attr('data-price'));
                var thisComparePrice =  parseInt($optionSelected.attr('data-compare-price') ? $optionSelected.attr('data-compare-price') : $optionSelected.attr('data-price'));
                if (thisSubQnt > 0) {
                    currentTotalSubscription += thisSubQnt * thisSubPrice;
                    currentTotalSubscriptionCompare += thisSubQnt * (isSubscriptionOos ? 0 : thisComparePrice);
                }
                if (thisOneTimeQnt > 0) {
                    currentTotalOneOff += thisOneTimeQnt * thisOneTimePrice;
                    currentTotalOneOffCompare += thisOneTimeQnt * thisComparePrice;
                }
            });

            if (subscriptionSpecialOffersInCart.length){
                var addOffersToSubscription = true;
                var mainVariantId = +$('.subscription-product-main .product-single__variants option:selected').val();
                if (subscriptionSpecialOffersSettings.only_for_some_primary_variants && subscriptionSpecialOffersSettings.only_for_some_primary_variants.indexOf(mainVariantId) < 0) {
                    addOffersToSubscription = false;
                }
                if (addOffersToSubscription){
                    $.each(subscriptionSpecialOffersInCart, function(i, item){
                        var offerSettings = subscriptionSpecialOffersSettings.products.filter(function(product){
                            return product.handle === item.handle;
                        });
                        currentTotalSubscription += offerSettings[0].price;
                        currentTotalSubscriptionCompare += item.original_price;
                    });
                }
            }

            currentTotalAll = currentTotalOneOff + currentTotalSubscription;
            currentTotalAllCompare = currentTotalOneOffCompare + currentTotalSubscriptionCompare + includeShippingInTotal;

            if (!initialTotalPrice) {
                initialTotalPrice = currentTotalAll;
            }
            $currentTotalSubscription.html(theme.Currency.formatMoney(currentTotalSubscription, theme.strings.moneyFormat));
            $currentTotalAll.html(theme.Currency.formatMoney(currentTotalAll, theme.strings.moneyFormat));
            $currentTotalAllCompare.html(theme.Currency.formatMoney(currentTotalAllCompare, theme.strings.moneyFormat));
            $subscriptionSavings.html(theme.Currency.formatMoney(currentTotalAllCompare - currentTotalAll, theme.strings.moneyFormat));
            if (currentTotalAllCompare > currentTotalAll){
                $currentTotalAllCompare.show();
            }
            else {
                $currentTotalAllCompare.hide();
            }
            if (!currentTotalOneOff) {
                $('.one-time-title', $confirmTable).slideUp(200, function (){
                    $(this).remove();
                });
            }
        };

        function addProductsToConfirm() {
            var $subscriptionVariants = $('.subscription-product-active .product-single__variants option:selected');
            var $oneOffVariants = $('.one-time-product-active .product-single__variants option:selected');
            var frequency = $('[name="frequency"]:checked');
            var frequencyOption = frequency.attr('data-option-name');
            var frequencyNote = frequency.attr('data-option-note') ? frequency.attr('data-option-note') : '';
            $('.appended-item', $confirmTable).remove();
            $('.one-time-title', $confirmTable).remove();
            $subscriptionVariants.each(function(){
                addProductToConfirm($(this));
            });
            if ($oneOffVariants.length){
                $('<div class="content-block-title one-time-title upcase">One-time</div>').appendTo($confirmTable);
                $oneOffVariants.each(function(){
                    addProductToConfirm($(this), true);
                });
            }
            if (subscriptionSpecialOffersInCart.length){
                var addOffersToSubscription = true;
                var mainVariantId = +$('.subscription-product-main .product-single__variants option:selected').val();
                if (subscriptionSpecialOffersSettings.only_for_some_primary_variants && subscriptionSpecialOffersSettings.only_for_some_primary_variants.indexOf(mainVariantId) < 0) {
                    addOffersToSubscription = false;
                }
                if (addOffersToSubscription){
                    $.each(subscriptionSpecialOffersInCart, function(i, item){
                        var $relatedOption = $('.subscription-product-offer .product-single__variants option[value="'+item.id+'"]');
                        item.ind = i;
                        addProductToConfirm($relatedOption, false, item);
                    });
                }
            }
            $('.frequency-value').text(frequencyOption);
            $('.frequency-note').text(frequencyNote);
        };

        function addProductToConfirm($option, oneTime, subscriptionSpecialOffer){
            var $container = $option.closest('.subscription-product');
            if ($option.attr('value') == undefined) {
                return false;
            }
            var variantTitle = $option.attr('data-subscribe-variant-title');
            var note = '';
            var thisSubPrice = $option.attr('data-subscribe-price') ? parseInt($option.attr('data-subscribe-price')) : 0;
            var thisSubComparePrice = parseInt($option.attr('data-price'));
            var thisOneTimePrice = $option.attr('data-custom-price') ? parseInt($option.attr('data-custom-price')) : parseInt($option.attr('data-price'));
            var thisOneTimeComparePrice = $option.attr('data-compare-price') ? parseInt($option.attr('data-compare-price')) : parseInt($option.attr('data-price'));
            var shippingPrice = 0;
            var isMainProduct = $container.hasClass('subscription-product-main');
            var step = $option.attr('data-step');
            var row = $('.append-empty-item', $confirmTable);
            var newRow = row.clone(true);
            if (variantTitle === 'Default Title'){
                variantTitle = false;
            }
            newRow.attr('variant-id', $option.attr('value'));
            newRow.removeClass('append-empty-item').addClass('appended-item');
            if (isMainProduct){
                var qty = +$option.attr('data-subscribe-qnt');
                newRow.addClass('appended-main-item');
                shippingPrice = includeShippingInTotal;
            }
            else {
                var qty = oneTime ? +$container.find('.js-qty__num-one-time').val() : +$container.find('.js-qty__num-subscribe').val();
            }

            if ($('.subscription-product-note', $container).length){
                note = $('.subscription-product-note', $container).html();
            }
            else if ($option.attr('data-per-pack-qnt')) {
                note = $('<p>' + $option.attr('data-per-pack-qnt') * qty + ' ' + $option.attr('data-product-type') + '</p>').html();
            }

            if (subscriptionSpecialOffer) {
                var offerSettings = subscriptionSpecialOffersSettings.products.filter(function(product){
                    return product.handle === subscriptionSpecialOffer.handle;
                });
                thisSubPrice = offerSettings[0].price;
                qty = 1;
                if (note) {
                    var $note = $('<span></span>').html(note);
                    $('.packs-qnt', $note).text(qty + ' x ' + $option.attr('data-pack-type').split('/')[0]);
                    $('.per-pack-qnt', $note).text($option.attr('data-per-pack') * qty);
                    note = $note.html();
                }
                $('<p class="subscription-special-offer-message paragraph--small text-center">'+ theme.strings.subscriptionSpecialOfferMessage +'</p>').appendTo($('.product-meta', newRow));
                newRow.addClass('appended-special-offer-item');
            }

            $('img', newRow).attr('src', $option.attr('data-subscribe-variant-img')).attr('alt', variantTitle);
            $('.product-title', newRow).html('<span>' + $option.attr('data-subscribe-title') + '</span> <span class="item-qnt"> x ' + qty + '</span>');
            $('.product-options', newRow).html((variantTitle ? variantTitle + '<br>' : '') + note);

            if (oneTime) {
                $('.subscribe-price', newRow).text(theme.Currency.formatMoney((thisOneTimePrice * qty), theme.strings.moneyFormat));
                if (thisOneTimeComparePrice > thisOneTimePrice){
                    $('.compare-at-price', newRow).text(theme.Currency.formatMoney((thisOneTimeComparePrice * qty + shippingPrice), theme.strings.moneyFormat));
                }
            }
            else {
                $('.subscribe-price', newRow).text(theme.Currency.formatMoney((thisSubPrice * qty), theme.strings.moneyFormat));
                if (thisSubComparePrice > thisSubPrice){
                    $('.compare-at-price', newRow).text(theme.Currency.formatMoney((thisSubComparePrice * qty + shippingPrice), theme.strings.moneyFormat));
                }
            }

            $('[data-step-to]', newRow).attr('data-step-to', step);
            $('.remove-item', newRow).on('click', function(){
                if (isMainProduct) {
                    return;
                }
                if (subscriptionSpecialOffer){
                    subscriptionSpecialOffersInCart.splice(subscriptionSpecialOffer.ind, 1);
                }
                else if (oneTime) {
                    $('.remove-one-time', $container).trigger('click');
                    // $container.removeClass('one-time-product-active');
                }
                else {
                    $('.remove-from-subscription', $container).trigger('click');
                    // $container.removeClass('subscription-product-active');
                }

                if ($container.hasClass('additional-product-options')){
                    $('.remove-additional-variant', $container).trigger('click');
                }
                newRow.slideUp(100, function(){
                    $(this).remove();
                    calcCurrentTotal();
                });
            });
            $confirmTable.append(newRow);
        };

        function goToStep(nextStep) {
            if (isUpdatePage){
                if (nextStep < 1){
                    window.location.href = document.referrer;
                }
                setTimeout(function (){
                    $('.subscribe-page-loading').removeClass('subscribe-page-loading');
                },50);
                return;
            }
            $('.top-message').hide();
            $('.subscribe-page-main-wrapper').removeClass('confirm-step');
            if (nextStep > 1 && !$('.subscribe-section[data-step="1"] .subscription-product-main.subscription-product-active').length){
                goToStep(1);
                return;
            }
            if (nextStep === 1 && !document.referrer){
                $mainPrevBtn.hide();
            }
            else {
                $mainPrevBtn.show();
            }
            if (nextStep < 1){
                window.location.href = document.referrer;
                return;
            }
            if (nextStep == maxStep){
                addProductsToConfirm();
                $('.nav_next').hide();
                $('.nav_add').show();
                $('.subscribe-page-main-wrapper').addClass('confirm-step');
            }
            else {
                $('.nav_add').hide();
                $('.nav_next').show();
            }
            $('.subscribe-section.active').hide().removeClass('active');
            $('.subscribe-section-prev').removeClass('subscribe-section-prev');
            $("html, body").animate({ scrollTop: 0 }, 0);
            if (nextStep < currentStep){
                $('.subscribe-section[data-step="' + nextStep + '"]').addClass('subscribe-section-prev');
            }
            $('.subscribe-section[data-step="' + nextStep + '"]').fadeIn(500, function (){
                $(window).trigger('stepChanged');
                $(document).trigger('stepChanged');
            }).addClass('active');
            changeButtonClass();
            $('.subscribe-page-loading').removeClass('subscribe-page-loading');
            updateQueryStringParam('step', $('.subscribe-section[data-step="' + nextStep + '"]').attr('data-url'));
            currentStep = nextStep;
        };

        function addOrUpdate() {
            removeSubscription(addSusbcriptionToCart);
        };

        function getSubscriptionProducts(callback) {
            subscriptionProducts = [];
            allSelectedProducts = [];
            unpausedSubscriptionProducts = [];
            oosProducts = [];
            oneTimeProducts = [];
            var frequencyVal = $('[name="frequency"]:checked').val();
            var mainVariantId;
            $('.subscription-product-active .product-single__variants option:selected').each(function () {
                var $this = $(this);
                var $thisContainer = $this.closest('.subscription-product');
                var isMainProduct = $thisContainer.hasClass('subscription-product-main');
                var variantId = $this.attr('value');
                var subscriptionPlanIds = JSON.parse($this.attr('data-subscription-plans'));
                var subscriptionPlanOptions = JSON.parse($this.attr('data-subscription-plans-options'));
                var lineId = $(this).attr('data-line-id') ? $(this).attr('data-line-id') : false;
                var isExtraProduct = $(this).attr('data-extra-product') == 'yes';
                var frequencyIndexInOptions = subscriptionPlanOptions.indexOf(frequencyVal);
                var isUnpausedProduct = $thisContainer.hasClass('subscription-product-unpaused');
                if (isMainProduct){
                    mainVariantId = +variantId;
                }
                if ($thisContainer.hasClass('subscription-product-main')){
                    var variantQnt = parseInt($this.attr('data-subscribe-qnt'));
                }
                else {
                    var variantQnt = parseInt($('.js-qty__num-subscribe', $thisContainer).val());
                }
                var lineProp = {};
                var subscriptionType = $('.subscribe-page-wrapper').attr('data-subscription-type');
                lineProp['_gwa_subscription'] = '1';
                if (subscriptionType){
                    lineProp['_gwa_subscription_type'] = subscriptionType;
                }
                if (isExtraProduct) {
                    extraProducts = true;
                }
                if (subscriptionId) {
                    lineProp['gwa_subscription_id'] = subscriptionId;
                    if (lineId){
                        lineProp['line_id'] = lineId;
                    }
                }
                if (variantQnt > 0 && !isUnpausedProduct) {
                    var productIsNew = true;
                    $.each(subscriptionProducts, function(i, product){
                        if (product.id === variantId && product.selling_plan === subscriptionPlanIds[frequencyIndexInOptions]){
                            product.quantity += variantQnt;
                            productIsNew = false;
                        }
                    });
                    if (productIsNew) {
                        subscriptionProducts.push({
                            id: variantId,
                            quantity: variantQnt,
                            selling_plan: subscriptionPlanIds[frequencyIndexInOptions],
                            properties: lineProp
                        });
                    }
                }
                else if (isUnpausedProduct && lineId){
                    unpausedSubscriptionProducts.push(lineId);
                }
            });

            $('.one-time-product-active .product-single__variants option:selected').each(function (){
                var $this = $(this);
                var $thisContainer = $this.closest('.subscription-product');
                var customPrice = $this.attr('data-custom-price');
                var variantId = $this.attr('value');
                var variantQnt = parseInt($('.js-qty__num-one-time', $thisContainer).val());
                var productObj = {
                    id: variantId,
                    quantity: variantQnt
                }
                if (customPrice) {
                    productObj.properties = {
                        "_custom_price": "true"
                    }
                }
                if (variantQnt > 0) {
                    oneTimeProducts.push(productObj);
                }
            });

            $('.subscription-oos-product-active .product-single__variants option:selected').each(function (){
                var $this = $(this);
                var $thisContainer = $this.closest('.subscription-product');
                var variantId = $this.attr('value');
                var variantQnt = parseInt($('.js-qty__num-subscribe', $thisContainer).val());
                var lineId = $this.attr('data-line-id');
                var productObj = {
                    id: variantId,
                    quantity: variantQnt,
                    line_id: lineId,
                    purchase_type: "subscription"
                }
                if (variantQnt > 0) {
                    oosProducts.push(productObj);
                }
            });

            $('.one-time-oos-product-active .product-single__variants option:selected').each(function (){
                var $this = $(this);
                var $thisContainer = $this.closest('.subscription-product');
                var variantId = $this.attr('value');
                var variantQnt = parseInt($('.js-qty__num-one-time', $thisContainer).val());
                var lineId = $this.attr('data-one-time-line-id');
                var productObj = {
                    id: variantId,
                    quantity: variantQnt,
                    line_id: lineId,
                    purchase_type: "one_time"
                }
                if (variantQnt > 0) {
                    oosProducts.push(productObj);
                }
            });

            if (subscriptionSpecialOffersInCart) {
                var addOffersToSubscription = true;
                if (subscriptionSpecialOffersSettings.only_for_some_primary_variants && subscriptionSpecialOffersSettings.only_for_some_primary_variants.indexOf(mainVariantId) < 0) {
                    addOffersToSubscription = false;
                }

                if (addOffersToSubscription){
                    $.each(subscriptionSpecialOffersInCart, function(i, item){
                        var $relatedOption = $('.subscription-product-offer .product-single__variants option[value="'+item.id+'"]');
                        var subscriptionPlanIds = JSON.parse($relatedOption.attr('data-subscription-plans'));
                        var subscriptionPlanOptions = JSON.parse($relatedOption.attr('data-subscription-plans-options'));
                        var frequencyIndexInOptions = subscriptionPlanOptions.indexOf(frequencyVal);
                        var lineProp = {};
                        var subscriptionType = $('.subscribe-page-wrapper').attr('data-subscription-type');
                        if (subscriptionType){
                            lineProp['_gwa_subscription_type'] = subscriptionType;
                        }
                        lineProp['_gwa_subscription'] = '1';
                        lineProp['_gwa_subscription_special_offer'] = '1';
                        subscriptionProducts.push({
                            id: item.id,
                            quantity: 1,
                            selling_plan: subscriptionPlanIds[frequencyIndexInOptions],
                            properties: lineProp
                        });
                    });
                }
            }

            allSelectedProducts = subscriptionProducts.concat(oneTimeProducts);
            callback();
        };

        function addSusbcriptionToCart() {
            if (allSelectedProducts.length) {
                $.ajax({
                    type:     'POST',
                    url:      window.Shopify.routes.root + 'cart/add.js',
                    data: {"items": allSelectedProducts},
                    dataType: 'json',
                    success:  function () {
                        onSubscriptionAdded();
                    },
                    error:    function (XMLHttpRequest, textStatus) {
                        console.log(XMLHttpRequest, textStatus);
                        $loadingOverlay.fadeOut(500);
                        $addOffersPopup.fadeOut(200);
                        $updatedPricePopup.fadeOut(200);
                        var data = eval('(' + XMLHttpRequest.responseText + ')');
                        if (data.message) {
                            if (data.status === 422) {
                                $("html, body").animate({ scrollTop: 0 }, 1000);
                                $('.top-message-text').text(data.description);
                                $('.top-message').slideDown(300);
                            }
                            else {
                                $("html, body").animate({ scrollTop: 0 }, 1000);
                                $('.top-message-text').text('Something went wrong. Please try again!');
                                $('.top-message').slideDown(300);
                            }
                        }
                    }
                });
            }
        };

        function onSubscriptionAdded() {
            if (subscriptionId) {
                var data = {
                    id: subscriptionId,
                    customerId: customerId,
                    action: 'update',
                    items: subscriptionProducts,
                    unpaused_items: unpausedSubscriptionProducts,
                    one_time_items: oneTimeProducts,
                    oos_items: oosProducts
                };

                $.ajax({
                    type: 'POST',
                    url: subscriptionUpdateUrl,
                    data: data,
                    success: function (response) {
                        if (response.status) {
                            removeSubscription(function () {
                                window.localStorage.setItem('top-message', 'Subscription updated - products changed');
                                window.localStorage.setItem('top-message-time', (new Date().getTime() / 1000).toString());
                                document.location.href = subscriptionUrl;
                            }, true);
                        } else {
                            $loadingOverlay.fadeOut(500);
                            $addOffersPopup.fadeOut(200);
                            $updatedPricePopup.fadeOut(200);
                            $("html, body").animate({ scrollTop: 0 }, 1000);
                            $('.top-message-text').text('Something went wrong. Please try again!');
                            $('.top-message').slideDown(300);
                            if (response.errors){
                                console.log(response.errors);
                            }
                        }
                    },
                    error: function(XMLHttpRequest, textStatus){
                        console.log('error');
                        console.log(XMLHttpRequest, textStatus);
                    }
                });
            }
            else {
                var checkSubscribeUrl = $('#checkSubscribeUrl');
                var url = checkSubscribeUrl.length > 0 ? checkSubscribeUrl.val() : window.Shopify.routes.root + 'cart';
                var subscriptionType = $('.subscribe-page-wrapper').attr('data-subscription-type');
                if (subscriptionType){
                    $.ajax({
                        type: 'POST',
                        url: window.Shopify.routes.root + 'cart/update.js',
                        dataType: 'json',
                        data: {
                            attributes: {
                                'primary_product_type': subscriptionType
                            }
                        },
                        success: function (response) {
                            document.location.href = url;
                        },
                        error: function(XMLHttpRequest, textStatus){
                            console.log('error');
                            console.log(XMLHttpRequest, textStatus);
                        }
                    });
                }
                else {
                    document.location.href = url;
                }

            }
        }

        function removeSubscription(callback, removeAll) {
            if (removeAll){
                $.ajax({
                    type: "POST",
                    url: window.Shopify.routes.root + 'cart/clear.js',
                    dataType: 'json',
                    success: function () {
                        callback();
                    },
                    error: function (XMLHttpRequest, textStatus) {
                        $loadingOverlay.fadeOut(500);
                        $addOffersPopup.fadeOut(200);
                        $updatedPricePopup.fadeOut(200);
                        $("html, body").animate({ scrollTop: 0 }, 1000);
                        $('.top-message-text').text('Something went wrong. Please try again!');
                        $('.top-message').slideDown(300);
                        console.log(XMLHttpRequest, textStatus);
                    }
                });
                return;
            }
            var cartQntArray = [];
            $.ajax({
                type:     'GET',
                url:      window.Shopify.routes.root + 'cart.js',
                dataType: 'json',
                success:  function (cart) {
                    var subscriptionInCart = false;
                    var anotherSubscriptionInCart = false;
                    var mainProductInCart = false;
                    var checkedMainVariantId = +$('.subscription-product-main option:checked').val();
                    for (i = 0; i < cart.items.length; i++) {
                        if (cart.items[i].selling_plan_allocation) {
                            cartQntArray.push(0);
                            subscriptionInCart = true;
                            if (mainSellingPlansIds && mainSellingPlansIds.indexOf(cart.items[i].selling_plan_allocation.selling_plan.id) >= 0){
                                mainProductInCart = true;
                            }
                            else if (relMainSellingPlansIds && relMainSellingPlansIds.indexOf(cart.items[i].selling_plan_allocation.selling_plan.id) >= 0){
                                mainProductInCart = true;
                            }
                        }
                        else if (switchNappiesToSubscription && $.isEmptyObject(cart.items[i].properties) && checkedMainVariantId === cart.items[i].id){
                            cartQntArray.push(0);
                        }
                        else if (switchNappiesToSubscription && $.isEmptyObject(cart.items[i].properties) && switchOffersToSubscription && switchOffersToSubscription.indexOf(cart.items[i].product_id) >=0){
                            var $addedAsSubscription = $('.subscription-product-active option[value="'+ cart.items[i].id +'"]');
                            if ($addedAsSubscription.length){
                                cartQntArray.push(0);
                            }
                            else {
                                cartQntArray.push(cart.items[i].quantity);
                            }
                        }
                        else {
                            var $relatedOption = $('.one-time-enabled option[value="'+ cart.items[i].id +'"]');
                            var isCustomPriced = $relatedOption.attr('data-custom-price');
                            if ($relatedOption.length && !isCustomPriced && $.isEmptyObject(cart.items[i].properties)){
                                cartQntArray.push(0);
                            }
                            else if ($relatedOption.length && isCustomPriced && cart.items[i].properties['_custom_price']) {
                                cartQntArray.push(0);
                            }
                            else {
                                cartQntArray.push(cart.items[i].quantity);
                            }
                        }
                        if (cart.items[i].properties && cart.items[i].properties['_bundle_id'] && cart.items[i].selling_plan_allocation){
                            anotherSubscriptionInCart = true;
                        }
                    }

                    if ((mainSellingPlansIds || relMainSellingPlansIds) && subscriptionInCart && !mainProductInCart){
                        anotherSubscriptionInCart = true;
                    }
                    if (anotherSubscriptionInCart) {
                        $loadingOverlay.fadeOut(500);
                        $addOffersPopup.fadeOut(200);
                        $updatedPricePopup.fadeOut(200);
                        $('#subscription-in-cart-popup').fadeIn(300);
                        return;
                    }
                    // return;
                    $.ajax({
                        type:     'POST',
                        url:      window.Shopify.routes.root + 'cart/update.js',
                        data:     {updates: cartQntArray},
                        dataType: 'json',
                        success:  function () {
                            callback();
                        },
                        error:    function (XMLHttpRequest, textStatus) {
                            $loadingOverlay.fadeOut(500);
                            $addOffersPopup.fadeOut(200);
                            $updatedPricePopup.fadeOut(200);
                            $("html, body").animate({ scrollTop: 0 }, 1000);
                            $('.top-message-text').text('Something went wrong. Please try again!');
                            $('.top-message').slideDown(300);
                            console.log(XMLHttpRequest, textStatus);
                        }
                    });
                }
            });
        }

        function updateQueryStringParam(key, value) {
            if (isUpdatePage){
                return;
            }
            var baseUrl = [location.protocol, '//', location.host, location.pathname].join(''),
                urlQueryString = document.location.search,
                newParam = key + '=' + value,
                params = '?' + newParam;
            if (urlQueryString) {
                var updateRegex = new RegExp('([\?&])' + key + '[^&]*');
                var removeRegex = new RegExp('([\?&])' + key + '=[^&;]+[&;]?');
                if( typeof value == 'undefined' || value == null || value == '' ) { // Remove param if value is empty
                    params = urlQueryString.replace(removeRegex, "$1");
                    params = params.replace( /[&;]$/, "" );
                } else if (urlQueryString.match(updateRegex) !== null) { // If param exists already, update it
                    params = urlQueryString.replace(updateRegex, "$1" + newParam);
                } else { // Otherwise, add it to end of query string
                    params = urlQueryString + '&' + newParam;
                }
            }
            params = params == '?' ? '' : params;
            window.history.replaceState({}, "", baseUrl + params);
        };

        function getQueryVariable(variable) {
            var query = window.location.search.substring(1);
            var vars = query.split('&');
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split('=');
                if (decodeURIComponent(pair[0]) == variable) {
                    if (pair[1] && pair[1].length) {
                        return decodeURIComponent(pair[1]);
                    }
                    else {
                        return false;
                    }
                }
            }
            return false;
        };

        function adjustOfferBlockHeight(){
            var $subscribeSections = $('.collection-products').filter(function (){
                return $('.has-additional-variants', $(this)).length > 0;
            })
            $subscribeSections.each(function (){
                var $subscribeSection = $(this);
                var $allSubscriptionBlocks = $('.subscription-product-offer', $subscribeSection);
                var $elementsToObserve = $('.item-footer', $allSubscriptionBlocks);
                changeSize();
                $elementsToObserve.each(function (){
                    new ResizeObserver(changeSize).observe($(this)[0]);
                });
                function changeSize() {
                    $allSubscriptionBlocks.css('height', 'auto');
                    var maxHeight = Math.max.apply(null, $allSubscriptionBlocks.map(function() {
                        return $(this)[0].clientHeight;
                    }).get());
                    $allSubscriptionBlocks.css('height', maxHeight);
                }
            });
        }

        function addShadowToHeader(){
            if ($(window).scrollTop() > 0 && !$('.subscription-page-header').hasClass('with-shadow')) {
                $('.subscription-page-header').addClass('with-shadow');
            }
            else if ($(window).scrollTop() == 0){
                $('.subscription-page-header').removeClass('with-shadow');
            }
        }

        function topMessage(){
            // Check for top message
            var topMessage = window.localStorage.getItem('top-message'),
                topMessageTime = window.localStorage.getItem('top-message-time');

            // If we have a message and this message not older 1 minute
            if (topMessage && (new Date().getTime() / 1000) - parseInt(topMessageTime) < 60) {
                $('<div class="top-message" style="display: block;">'+topMessage+'</div>').insertBefore($('div.grid:first'));
                window.localStorage.removeItem('top-message');
                window.localStorage.removeItem('top-message-time');
                setTimeout(function(){
                    $('html, body').animate({
                        scrollTop: 0
                    },500);
                }, 100);
            }
        };

        function initCollectionScroll(){
            var $sliders = $('.collection-products-wrapper');
            if (!$sliders.length){
                return;
            }
            $sliders.each(function(){
                var slider = this;
                var $slider = $(this);
                var $sliderContainer = $slider.closest('.section-subscribe-collection');
                var pos = {left: 0, x: 0, dx: 0};
                var numOfSlides = $('.grid__item', $slider).length;
                var $firstSlide = $('.grid__item', $slider).first();
                $slider.on('scroll', function(e){
                    if (slider.scrollLeft === 0){
                        $('.arrow-prev', $sliderContainer).removeClass('active');
                    }
                    else if (slider.scrollLeft === slider.scrollWidth - slider.clientWidth){
                        $('.arrow-next', $sliderContainer).removeClass('active');
                    }
                    else {
                        $('.arrow-prev', $sliderContainer).addClass('active');
                        $('.arrow-next', $sliderContainer).addClass('active');
                    }

                });
                var mouseDownHandler = function (e) {
                    if (e.type === 'mousedown' && e.button !== 0){
                        return;
                    }
                    if ($(e.target).hasClass('js-qty__num')){
                        return;
                    }
                    pos = {
                        left: slider.scrollLeft,
                        x: e.clientX,
                        dx: 0
                    };
                    document.addEventListener('mousemove', mouseMoveHandler);
                    document.addEventListener('mouseup', mouseUpHandler);
                    slider.removeEventListener('click', linkClickHandler);
                    slider.addEventListener('click', linkClickHandler);
                    if (e.target.closest('.custom-ratio-image-wrapper')){
                        $(e.target.closest('.custom-ratio-image-wrapper')).removeClass('drag-start');
                        $(e.target.closest('.custom-ratio-image-wrapper')).addClass('drag-start');
                    }
                };
                var mouseMoveHandler = function (e) {
                    e.preventDefault();
                    var dx = e.clientX - pos.x;
                    pos.dx = dx;
                    slider.scrollLeft = pos.left - dx;
                };
                var mouseUpHandler = function (e) {
                    document.removeEventListener('mousemove', mouseMoveHandler);
                    document.removeEventListener('mouseup', mouseUpHandler);
                    if (e.target.closest('a') && pos.dx === 0) {
                        slider.removeEventListener('click', linkClickHandler);
                        e.target.closest('a').click();
                    }
                    else if (e.target.closest('.custom-ratio-image-wrapper') && pos.dx === 0){
                        $(e.target.closest('.custom-ratio-image-wrapper')).removeClass('drag-start');
                    }
                };
                slider.addEventListener('mousedown', mouseDownHandler);

                updateSlider();
                window.addEventListener('resize', function(){
                    updateSlider();
                });
                $(document).on('stepChanged', function(){
                    updateSlider();
                });

                $('.arrow-next', $sliderContainer).click(function() {
                    var sliderWidth = slider.getBoundingClientRect().width;
                    if (slider.scrollLeft === slider.scrollWidth - sliderWidth) {
                        return;
                    }
                    var slideWidth = $firstSlide[0].getBoundingClientRect().width + 16;
                    var slidesScrolled = Math.round(slider.scrollLeft / slideWidth);
                    var calcScrollDistance = slidesScrolled * slideWidth;
                    var diff = calcScrollDistance - slider.scrollLeft;
                    var newScrollLeft = slider.scrollLeft + sliderWidth + 16 + diff;
                    $slider.animate( { scrollLeft: newScrollLeft }, 500);
                });

                $('.arrow-prev', $sliderContainer).click(function() {
                    var sliderWidth = slider.getBoundingClientRect().width;
                    if (slider.scrollLeft === 0) {
                        return;
                    }
                    var slideWidth = $firstSlide[0].getBoundingClientRect().width + 16;
                    var slidesScrolled = Math.round(slider.scrollLeft / slideWidth);
                    var calcScrollDistance = slidesScrolled * slideWidth;
                    var diff = calcScrollDistance - slider.scrollLeft;
                    var newScrollLeft = slider.scrollLeft  - sliderWidth - 16 + diff;
                    $slider.animate( { scrollLeft: newScrollLeft }, 500);
                });

                function updateSlider() {
                    if (slider.scrollWidth > slider.clientWidth){
                        slider.style.cursor = 'grab';
                        $('.nav-arrows', $sliderContainer).show();
                    }
                    else {
                        slider.style.cursor = 'auto';
                        $('.nav-arrows', $sliderContainer).hide();
                    }
                }
            });
            function linkClickHandler (e){
                if (e.target.closest('a')) {
                    e.preventDefault();
                    return false;
                }
            };

        };
    };
})();